<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-07-13 10:18:28
 * @Description: SIS报警
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="h-100">
    <el-table :data="sisData" class="h-100">
      <el-table-column
        v-for="col in columns"
        :prop="col.prop"
        :key="col.prop"
        :label="col.label"
        :width="col.width"
      ></el-table-column>
    </el-table>
    <el-pagination
      class="m-t-5 r"
      @current-change="currentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.size"
      layout="total, prev, pager, next"
      :total="page.total"
      background
      :pager-count="5"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: {
        size: 15,
        total: 10,
        currentPage: 1,
      },
      sisData: [
        {
          index: 1,
          code: '',
          alarmEquipment: '锅炉',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '14',
        },
        {
          index: 2,
          code: '',
          alarmEquipment: '汽轮机',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '12',
        },
        {
          index: 3,
          code: '',
          alarmEquipment: '发电机',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '8',
        },
        {
          index: 4,
          code: '',
          alarmEquipment: '凝结水泵',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '4',
        },
        {
          index: 5,
          code: '',
          alarmEquipment: '循环水泵',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '8',
        },
        {
          index: 6,
          code: '',
          alarmEquipment: '定冷水泵',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '3',
        },
        {
          index: 7,
          code: '',
          alarmEquipment: '油泵',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '4',
        },
        {
          index: 8,
          code: '',
          alarmEquipment: '一次风机',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '3',
        },
        {
          index: 9,
          code: '',
          alarmEquipment: '二次风机',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '4',
        },
        {
          index: 10,
          code: '',
          alarmEquipment: '引风机',
          alarmType: '超限',
          alarmDate: '2021-08-31 19:23:12',
          alarmEndDate: '2021-08-31 19:23:12',
          minimumThreshold: '1',
          maximumThreshold: '10',
          currentValue: '5',
        },
      ],
      columns: [
        {
          prop: 'index',
          label: '序号',
          width: '50px',
        },
        {
          prop: 'alarmEquipment',
          label: '报警设备',
        },
        {
          prop: 'alarmType',
          label: '报警类型',
        },
        {
          prop: 'alarmDate',
          label: '报警时间',
          width: '150px',
        },
        {
          prop: 'alarmEndDate',
          label: '报警结束时间',
          width: '150px',
        },
        {
          prop: 'minimumThreshold',
          label: '最小阈值',
        },
        {
          prop: 'maximumThreshold',
          label: '最大阈值',
        },
        {
          prop: 'currentValue',
          label: '当前值',
        },
      ],
    }
  },
  methods: {
    currentChange() {
      console.log('currentChange')
    },
  },
}
</script>
<style lang="scss" scoped>

/deep/ .el-table {
  background: #ffffff61 !important;
  thead th {
    padding: 0px;
    background: none !important;
  }
  &__body-wrapper {
    background: none !important;
    height: calc(100% - 25px);
    overflow-y: scroll;
  }
  &__empty-block {
    background: none !important;
  }
  &__expanded-cell {
    background: #ffffff40 !important;
    padding: 0px 10px;
    padding-left: 20px;
  }
}

</style>
